module.exports = __webpack_public_path__ + "img/tc.tc7bce312.svg";